<template>
  <div id="app" class="sa-wrapper">
    <div class="sa-container">
      <router-view></router-view>
      <div v-if="alertMessage.msg" class="sa-alert sa-alert-fixed" :class="alertMessage.class">
          <span>{{alertMessage.msg}}</span> <i class="icon-close sa-a-close" v-on:click="resetAlertMessage()"></i>
      </div>
    </div>
    <div class="sa-footer">
        <div class="sa-social-footer">
            <a href="https://www.linkedin.com/company/sanar-health-care/" target="_blank"><i class="icon-linkedin"></i></a>
            <a href="https://www.facebook.com/sanarksa/" target="_blank"><i class="icon-fb"></i></a>
            <a href="https://twitter.com/SANARKSA?lang=ar" target="_blank" ><i class="icon-twitter"></i></a>
            <a href="https://www.instagram.com/sanarksa" target="_blank"><i class="icon-instagram"></i></a>
        </div>
        <div class="sa-footer-list">
            <a>© 2020 Sanar</a>
            <!-- <a>Privacy Policy</a>
            <a>Terms and Conditions</a> -->
        </div>
    </div>
        <force-update :data="updateData" v-show="updateApp" />
  </div>
</template>
<script>
import FooterVue from '../components/common/Footer.vue'
import ForceUpdate from '../components/common/ForceUpdate.vue'
import { oh_url,  version } from "../../config/endpoints";

import { mapState } from 'vuex'
export default {
   watch: {
      alertMessage: {
        deep: true,
        immediate: true,
        handler() {
          if (this.alertMessage.msg) {
            setTimeout(() => {
              this.$store.dispatch('SET_ALERTMESSAGE', { 'msg': '', class: '' })
            }, 5000)
          }
        }
      }
    },
    computed: mapState(['alertMessage']),
  components: {
    'footer-bar': FooterVue,
    'force-update': ForceUpdate
  },
   methods: {
    resetAlertMessage() {
        this.$store.dispatch('SET_ALERTMESSAGE', { 'msg': '', class: '' })
      }
  },
  data () {
    return { 
      updateApp:false,
      updateData: {}
      }
  },
  mounted(){
    console.log(_self);
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: {
            mtype: [],
          },
        })
        .then((response) => {
          if (response.status == 1000) {
            _self.updateData = response.data.prodesktop;
             if (_self.updateData.versionnumber_desktop != version) {
              _self.updateApp = true;
             }
          }else {
            _self.updateApp = false;
          }
        })
        .catch((e) => {
         // console.log(e);
        });
  }
}
</script>
